import React from "react";
import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import { getMostRecentPosts } from "../api/getMostRecentPosts";

class MostRecentContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, items: [] };
  }
  fetch = () => {
    this.props.request(this.state.page).then(({ data }) => {
      const total = 30;

      const items = (data && data.posts) || [];
      const results = this.props.count < 30 && this.props.count < items.length ? items.slice(0, this.props.count) : items;

      const hasMore = !!(results.length < total);
      this.setState({ items: results, page: (this.state.page += 1), hasMore });
    });
  };
}

MostRecentContainer.defaultProps = { count: 30 };
export default CreateContainer(getMostRecentPosts, MostRecentContainer);
